import objectIsEmpty from "common/utils/objectIsEmpty";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_51: DocMigration = {
  maxSchemaVersion: "0.0.51",
  description: "Cleanup electrical entries to reduce doc size",
  apply(json: any) {
    const { electricalSystem } = json;

    // unused field
    for (const key in electricalSystem.embeddedGroups) {
      const group = electricalSystem.embeddedGroups[key];
      if (group.clearExistingLoadsInRoom !== undefined) {
        delete group.clearExistingLoadsInRoom;
      }
    }

    for (const key in electricalSystem.roomClearRules) {
      if (electricalSystem.roomClearRules[key] === false) {
        delete electricalSystem.roomClearRules[key];
      }
    }
    for (const key in electricalSystem.roomEmbeddedGroups) {
      if (objectIsEmpty(electricalSystem.roomEmbeddedGroups[key])) {
        delete electricalSystem.roomEmbeddedGroups[key];
      }
    }
    for (const key in electricalSystem.roomIndependentLoadArrays) {
      if (objectIsEmpty(electricalSystem.roomIndependentLoadArrays[key])) {
        delete electricalSystem.roomIndependentLoadArrays[key];
      }
    }
    return json;
  },
};

export default migration_0_0_51;
